function escapeHtml(value) {
  return String(value === null || value === undefined ? '-' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function parseLaunchTheProductCreateResult(data) {
  if (!data) return {}
  if (typeof data === 'string') {
    try {
      return JSON.parse(data)
    } catch (e) {
      return {}
    }
  }
  return typeof data === 'object' ? data : {}
}

export function getLaunchTheProductResultList(result, key) {
  return Array.isArray(result && result[key]) ? result[key] : []
}

function renderList(items, renderItem) {
  if (!items.length) return '<div>无</div>'
  return '<ol style="margin:6px 0 0;padding-left:20px;">' + items.map(renderItem).join('') + '</ol>'
}

export function buildLaunchTheProductCreateResultHtml(result) {
  const successList = getLaunchTheProductResultList(result, '成功列表')
  const failedList = getLaunchTheProductResultList(result, '失败列表')
  const abnormalProducts = getLaunchTheProductResultList(result, '异常商品')
  const successCount = result['成功数量'] === undefined ? successList.length : result['成功数量']
  const failedCount = result['失败数量'] === undefined ? failedList.length : result['失败数量']

  return [
    '<div style="line-height:1.7;max-height:55vh;overflow:auto;word-break:break-all;">',
    '<div><strong>创建成功：', escapeHtml(successCount), ' 条；失败：', escapeHtml(failedCount), ' 条；跳过商品：', escapeHtml(abnormalProducts.length), ' 个。</strong></div>',
    '<div style="margin-top:10px;"><strong>成功明细</strong>',
    renderList(successList, (item) => '<li>任务：' + escapeHtml(item['任务名称']) + '；抖音号：' + escapeHtml(item['抖音账号ID']) + '；创建商品：' + escapeHtml(item['创建商品数量']) + '；跳过商品：' + escapeHtml(item['已跳过商品数量']) + '</li>'),
    '</div>',
    '<div style="margin-top:10px;"><strong>失败明细</strong>',
    renderList(failedList, (item) => '<li>抖音号：' + escapeHtml(item['抖音账号ID']) + '；原因：' + escapeHtml(item['异常原因']) + '</li>'),
    '</div>',
    '<div style="margin-top:10px;"><strong>本次跳过/临时隔离商品</strong>',
    renderList(abnormalProducts, (item) => '<li>商品：' + escapeHtml(item.productId) + '；广告主：' + escapeHtml(item.advertiserId) + '；抖音号：' + escapeHtml(item.aweMeId) + '；原因：' + escapeHtml(item['原因']) + '</li>'),
    '</div></div>'
  ].join('')
}
